import { memo, useMemo } from 'react';
import { useGetAssistantsQuery } from 'store/services/core/assistants';
import { useGetModuleByIdQuery } from 'store/services/core/modules';
import { useTemplateIdToModuleId } from 'utils/hooks/useTemplateIdToModuleId';
import { getChatbotHistoryScope } from 'utils/chatbotHistory';
import { useLogin } from 'contexts';
import { ChatbotWidget } from './ChatbotWidget';

const ChatbotBase = () => {
  const { data: allAssistantsData, isLoading: isAllAssistantsLoading } = useGetAssistantsQuery();
  const { user } = useLogin();
  const moduleId = useTemplateIdToModuleId();
  const { currentData: moduleData, isFetching: isModuleFetching } = useGetModuleByIdQuery({ id: moduleId ?? '' }, { skip: !moduleId });
  const isModuleInitialLoading = Boolean(moduleId && isModuleFetching && moduleData === undefined);
  const assistants = useMemo(() => {
    if (moduleId) return moduleData?.assistants ?? [];

    return allAssistantsData ?? [];
  }, [allAssistantsData, moduleData, moduleId]);
  if (!user?.tenant_id || !user.user_id) return null;

  const historyScope = getChatbotHistoryScope('admin', { tenantId: user.tenant_id, userId: user.user_id }, moduleId);

  return (
    <ChatbotWidget
      key={historyScope}
      assistants={assistants}
      historyScope={historyScope}
      isAssistantsLoading={moduleId ? isModuleInitialLoading : isAllAssistantsLoading}
      showAssistantPicker={assistants.length > 0}
      toggleButtonTestId="admin-toolbar-chatbot-button"
    />
  );
};

export const Chatbot = memo(ChatbotBase);
